export default __webpack_public_path__ + "static/media/Trapezoid.0e393783.svg";